<template>
  <div id="profilePage">
    <HeaderParticipant :participants="participants" :participant="participant" @selectParticipants="selectParticipants"
      @changeSelect="changeSelect" />
      
    <v-row :class="{ 'mt-4': !age18 }">
      <v-col cols="12" v-if="loadingProfile" style="height:300px;">
        <v-skeleton-loader type="card-heading, image"></v-skeleton-loader>
      </v-col>
      <v-col cols="12" md="12" sm="12" v-else>
        <v-dialog v-model="dialog" width="500">
          <v-card class="mx-auto" style="max-width: 500px;">
            <v-card-title>{{ $t("profile.reset_password") }}</v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="form">
                <v-text-field 
                  v-model="new_pass" 
                  outlined dense 
                  :label="$t('profile.new_pass')" 
                  autocomplete="off"
                  :type="show2 ? 'text' : 'password'" 
                  :append-icon="show2 ? 'fa-eye' : 'fa-eye-slash'"
                  :error-messages="new_passwordErrors" 
                  @blur="$v.new_pass.$touch()"
                  @click:append="show2 = !show2"
                ></v-text-field>
                <v-text-field 
                  v-model="verify_pass" 
                  outlined dense autocomplete="off" 
                  :label="$t('profile.verify_pass')"
                  :type="show3 ? 'text' : 'password'" 
                  :append-icon="show3 ? 'fa-eye' : 'fa-eye-slash'"
                  :error-messages="passwordVerifyErrors" 
                  @click:append="show3 = !show3"
                ></v-text-field>
              </v-form>
              <v-list-item-subtitle v-if="wrong_password" style="text-align: center; color: red;">{{
      $t("profile.wrong_password") }}</v-list-item-subtitle>
              <v-divider></v-divider>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue-grey" class="ma-2 white--text" @click="submit">{{ $t("profile.reset_password")
                }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteImg" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              {{ $t("profile.title-deleteimg") }}
            </v-card-title>
            <v-card-text>
              {{ $t("profile.subtitle-deleteimg") }}
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :color="`${buttonColor}`" style="color:#fff" @click="deleteImg(userIdDelete)">
                {{ $t("profile.yes-deleteimg") }}
              </v-btn>
              <v-btn :color="`${buttonColor}`" style="color:#fff" @click="dialogDeleteImg = false">
                {{ $t("profile.no-deleteimg") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div class="ml-2 mr-2 mb-6" v-for="(part, i) in participantList" :key="i">
          <v-card class="elevation-4" :style="`background:${cardBGColor}`">
            <v-row class="pa-2">
              <!-- Image -->
              <v-col cols="12" md="3">
                <v-row class="boxAvatar">
                  <v-col cols="12" md="12" class="pb-0 text-center">
                    <div class="containImg">
                      <img class="imgAvatar" @error="loadPlaceholder" :src="part.image" />
                    </div>
                  </v-col>
                  <v-col cols="12" md="12" class="pt-0 pb-0 text-center avatar-action-buttons"
                    style="float: right; margin-bottom: 20px; margin-top: -13px;">
                    <v-btn icon color="rgba(0,0,0,.87)">
                      <v-icon dark @click="openDeleteImage(part.id)">
                        fas fa-trash-alt
                      </v-icon>
                    </v-btn>
                    <v-btn icon color="rgba(0,0,0,.87)">
                      <v-icon dark @click="openAvatarCopper(i)">
                        fas fa-pen
                      </v-icon>
                    </v-btn>
                    <Cropper :ref="`avatarCropperRef`" :participantId="part.id" :buttonColor="buttonColor"
                      @uploadCropperImage="uploadCropperImage" style="float: right;" />
                  </v-col>

                  <v-col cols="12" md="12" class="pt-0 pb-0 text-center">
                    <v-btn depressed class="btnImgCenter" @click="openSelfie(i)">
                      <v-icon left small>fas fa-camera</v-icon>
                      <span>{{ $t("profile.take-selfie") }}</span>
                    </v-btn>
                    <Cropper :ref="`selfieCropperRef`" :participantId="part.id" :buttonColor="buttonColor"
                      style="float: right;" type="selfie" @uploadCropperImage="uploadCropperImage" />
                  </v-col>
                  <v-col cols="12" md="12" class="pt-0 pb-0 text-center" style="margin-top:5px">
                    <v-btn v-if="userStore && part.userId == userStore.id" depressed class="btnImgCenter" @click="openResetPassword(part)">
                      <v-icon left small>fas fa-lock</v-icon>
                      <span>{{ $t("profile.change-password") }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="9">
                <v-row>
                  <v-col cols="12" md="4" class="pl-md-0 pb-0">
                    <v-text-field append-icon="fas fa-tag" class="input_small" outlined dense v-model="part.id"
                      :label="$t('profile.live-id')" disabled></v-text-field>
                  </v-col>
                  <v-col cols="12" md="8" class="pl-md-0 pb-0">
                    <v-text-field v-model="part.email" ref="email" class="text_id input_small" filled dense
                      :label="$t('profile.email')" @blur="send(part.id, part.email, 'email')"
                      append-icon="fas fa-envelope"
                      :placeholder="part._hasLivelapsEmail ? $t('profile.placeholder_enter_email') : ''"
                      :rules="[v => !!(v || '').length > 0 || $t('profile.error_empty')]"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" sm="12" class="py-0 pl-md-0">
                    <v-text-field v-model="part.firstName" ref="firstName" filled dense class="input_small"
                      append-icon="fas fa-user" :label="$t('profile.firstname')"
                      @blur="send(part.id, part.firstName, 'firstName')" :rules="nameRules"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" sm="12" class="py-0 pl-md-0">
                    <v-text-field v-model="part.lastName" ref="lastName" filled dense class="input_small"
                      append-icon="fas fa-user" :label="$t('profile.lastname')"
                      @blur="send(part.id, part.lastName, 'lastName')" :rules="nameRules"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                    <v-text-field v-model="part.phone" ref="phone" filled dense class="input_small"
                      :label="$t('profile.phone')" @blur="send(part.id, part.phone, 'phone')"
                      append-icon="fas fa-phone-alt" :rules="rules.phone"
                      @keypress="restrictFormat($event, part)"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                    <BDatePicker @send="send" :part="part" />
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                    <v-select 
                      @change="send(part.id, part.gender, 'gender')" 
                      class="input_small"
                      append-icon="fas fa-venus-mars" 
                      v-model="part.gender" 
                      item-text="text" 
                      item-value="value"
                      :items="genders" 
                      :rules="[v => (v || '').length > 0 || $t('registration.gender_required')]"
                      filled dense 
                      :label="$t('profile.gender')"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                    <div class="map-container for-profile" v-if="googleApiKey">
                      <label class="map-label">{{$t('profile.address')}}</label>
                      <i class="far fa-id-card map-icon"></i>
                      <ParticipantAddressAutocomplete 
                        :ref="`addressAutocomplete${part.id}`" 
                        :id="part.id" 
                        :placeHolder="part.address" 
                        :address="part.address"
                      />
                    </div>
                    <v-text-field 
                        v-else 
                        append-icon="far fa-id-card map-icon" 
                        class="input_small" 
                        @change="send(part.id, part.address, 'address')"
                        v-model="part.address" 
                        filled dense 
                        :label="$t('profile.address')"
                        :rules="[(v) => !!(v || '').length > 0 || $t('profile.error_empty')]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                    <v-text-field 
                      append-icon="fas fa-city" 
                      class="input_small" 
                      @change="send(part.id, part.city, 'city')"
                      v-model="part.city" 
                      filled dense 
                      :label="$t('profile.city')"
                      :rules="[(v) => !!(v || '').length > 0 || $t('profile.error_empty')]"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                      <v-select 
                        append-icon="far fa-flag" class="input_small" 
                        @change="send(part.id, part.state, 'state')" 
                        v-model="part.state" 
                        :items="stateItems[(part.country || '').length > 0 ? part.country : 'all']" 
                        filled dense :label="$t('profile.state')"
                        @click="verifyCountry(part)"
                        :no-data-text="$t('common.no_data')"
                      >
                        <template v-slot:selection="{ item }">
                          {{ item }}
                        </template>
                      </v-select>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                    <v-select 
                      append-icon="fas fa-globe-americas" 
                      class="input_small"
                      @change="send(part.id, part.country, 'country'); getStatesByCountry(part)" 
                      v-model="part.country"
                      :items="countryItems" 
                      filled dense 
                      :label="$t('profile.country')"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                    <v-text-field 
                      append-icon="far fa-id-card" 
                      v-model="part.zip" 
                      @blur="send(part.id, part.zip, 'zip')"
                      :label="$t('profile.zip')" 
                      filled dense 
                      class="input_small"
                      :rules="zipRules"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" class="py-0 pl-md-0">
                    <v-select 
                      append-icon="fas fa-globe" 
                      class="input_small"
                      @change="sendLanguage(part.id, part.languageCode, 'languageCode')" 
                      v-model="part.languageCode"
                      :items="langItems" 
                      filled dense 
                      :label="$t('profile.language')" 
                      item-value="value"
                      item-text="label"
                      :no-data-text="$t('common.no_data')"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <Snack :snack="snackbar" :snackMsg="msg_snackbar" :snackCol="color_snackbar" :timeout="6000" />
  </div>
</template>

<script>
import axios from "axios";
import ProfileService from "@/services/ProfileService";
import countryregion from "@/assets/data/countryregion.json";
import Snack from "@/components/notifications/Snack";
import LoginService from "@/services/LoginService";
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";
import
  {
    VCard, VCol, VRow, VBtn, VIcon, VSelect, VCardText, VDialog,
    VCardTitle, VCardActions, VSkeletonLoader, VTextField, VForm,
    VDivider, VSpacer
  } from 'vuetify/lib';
import { mapState, mapGetters } from 'vuex';
import GeneralService from "@/services/GeneralService";
import HeaderParticipant from "@/components/HeaderParticipant";
import AuthService from "@/services/AuthService";
import BDatePicker from "@/components/profile/BDatePicker.vue";
import Cropper from "@/components/images/Cropper.vue";
import LanguageService from '@/services/LanguageService';
import LocalStorageService from "@/services/LocalStorageService";
import ParticipantAddressAutocomplete from "@/components/profile/ParticipantAddressAutocomplete";

export default {
  mixins: [validationMixin],
  name: "Profile",
  components: {
    Snack,
    VCard, VCol, VRow, VBtn, VIcon, VSelect, VCardText, VDialog,
    VCardTitle, VCardActions, VSkeletonLoader, VTextField,
    VForm, VDivider, VSpacer, HeaderParticipant,
    BDatePicker,
    Cropper,
    ParticipantAddressAutocomplete
  },
  validations: {
    new_pass: {
      required,
      maxLength: value => !value || new TextEncoder().encode(value).length <= 72,
      minLength: minLength(8),
      strongPassword: function(value) {
        return this.$inputRules({ value }, 'strongPassword')
      }
    },
    verify_pass: {
      sameAsPassword: sameAs("new_pass")
    }
  },
  data()
  {
    const patternPhone = /^[0-9-]{10,12}$/;
    return {
      existImage: false,
      form: false,
      show2: false,
      show3: false,
      dialog: false,
      wrong_password: false,
      forgot_password: false,
      verify_pass: '',
      new_pass: '',
      profile: {
        id: 0,
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        date: null,
        gender: "",
        address: "",
        city: "",
        state: "",
        country: "",
        zip: ""
      },
      rules: {
        phone: [
          val => (val || "").length > 0 || this.$t('profile.error_empty'),
          val =>
          {

            let response
            if ((val || "").length > 0)
              response = !!val.match(patternPhone)

            if (val.match(/^[0-9-]{3,12}$/) && this.$refs['phone'])
            {
              /*--AQUI ESTA EL PROBLEMA DE WARNINGS EN LA CONSOLA--*/
              /*this.$refs['phone'][0].value=this.$refs['phone'][0].value.replaceAll("-", "")
              const lengthPhone = this.$refs['phone'][0].value.length
              
              if(lengthPhone>=4 && lengthPhone<7){
                  this.$refs['phone'][0].value=this.$refs['phone'][0].value.substring(0, 3)+"-"+this.$refs['phone'][0].value.substring(3)
              }

              if(lengthPhone>=7){
                this.$refs['phone'][0].value=this.$refs['phone'][0].value.replaceAll("-", "")
                this.$refs['phone'][0].value=this.$refs['phone'][0].value.substring(0, 3)+"-"+this.$refs['phone'][0].value.substring(3, 6) +"-"+this.$refs['phone'][0].value.substring(6)
              }
              if(lengthPhone<10){
                  return this.$t("profile.phone_invalid")
              }else if(lengthPhone>10){
                  return this.$t("profile.phone_invalid")
              }else{
                  this.$refs['phone'][0].value=this.$refs['phone'][0].value.replaceAll("-", "")
                  this.$refs['phone'][0].value=this.$refs['phone'][0].value.substring(0, 3) +"-"+this.$refs['phone'][0].value.substring(3, 6) +"-"+this.$refs['phone'][0].value.substring(6, 10)
              }*/
              /*-------------------------------------------------*/
            }
            if (!response)
              return this.$t("profile.phone_invalid")

            return true;
          }
        ],
      },
      buttonColor: "#000",
      headerColor: "#000",
      imageUrlProfile: "",
      countryItems: [],
      stateItems: [],
      cityItems: [],
      snackbar: false,
      msg_snackbar: '',
      color_snackbar: '',
      time_snack: 6000,
      menu: false,
      cardBGColor: "",
      authUserId: 0,
      dialogDeleteImg: false,
      errorImage: require("@/assets/images/partPlaceholder.jpg"),
      loadingProfile: true,
      dialogSelfie: false,
      showCam: true,
      picture: null,
      birthdayCurrent: null,
      userIdDelete: 0,
      profileIdSelect: null,
      userIdSelfie: 0,
      bandLoadingParticipants: false,
      participantList: [],
      languages: [],
      address: 'Calle trasierras 21 piso 2g',
      bPlacesAtive: false
    };
  },
  computed: {
    genders: function ()
    {
      const genders = [
        { value: "female", text: this.$t("profile.female") },
        { value: "male", text: this.$t("profile.male") }
      ];
      return genders;
    },
    new_passwordErrors()
    {
      const errors = [];
      if (!this.$v.new_pass.$dirty) return errors;

      !this.$v.new_pass.required && errors.push("Password is required");

      !this.$v.new_pass.strongPassword && 
        errors.push(this.$t('common.strong_password'));

      !this.$v.new_pass.minLength &&
        errors.push("Password must be at least 8 characters long");

      !this.$v.new_pass.maxLength &&
        errors.push(this.$t('common.password_max_length'));

      return errors;
    },
    passwordVerifyErrors()
    {
      const errors = [];
      if (!this.$v.new_pass.$dirty) return errors;

      !this.$v.verify_pass.sameAsPassword &&
        errors.push("Cannot verify password");
      return errors;
    },
    urlImage()
    {
      return this.loadImage(this.part)
    },
    ...mapGetters({
      addressDataComponentUpdateVersion: 'getAddressDataComponentUpdateVersion',
      addressDataComponentUpdateId: 'getAddressDataComponentUpdateId',
      addressDataComponents: 'getAddressDataComponents'
    }),
    ...mapState({
      userid: (state) => state.session.userid,
      content2(state)
      {
        return this.$t("common.selectParticipants.content_2", { livelapsId: state.session.userid })
      },
      age18: (state) => state.session.age18,
      userStore: (state) => state.session.user,
      participants: (state) => state.session.participants,
      participant: (state) => state.session.participantsSelected,
      //updateId: (state) => state.places.updateId,
      //addressDataComponents: (state) => state.places.addressDataComponents
      googleApiKey: (state) =>state.env.get('VUE_APP_GOOGLE_MAPS_API_KEY')
    }),
    nameRules()
    {
      return [
        (v) => !!(v || '').length > 0 || this.$t('profile.error_empty'),
        (v) =>
        {
          const patternName = /^[a-zA-Z\u00C0-\u017F\-' ]+/;
          const valueMatch = (v || '').match(patternName);
          return (!!valueMatch && valueMatch[0] == valueMatch.input) || this.$t('profile.invalid_field');
        }
      ];
    },
    langItems()
    {
      return this.languages.map(obj => ({
        value: obj.languageCode,
        label: obj.languageName
      }));
    },
    localeLang()
    {
      return this.$i18n.locale;
    },
    spaceCleaner() {
      return [
        this.new_pass,
        this.verify_pass
      ];
    },
    zipRules() {
      const patternZip = /([A-Za-z0-9-])+/;
      return [
        (v) => !!(v || '').length > 0 || this.$t('profile.error_empty'),
        (v) => (v || '').length <= 10 || this.$t('profile.error_zip_length'),
        (v) => patternZip.test(v || '') || this.$t('profile.error_zip_pattern')
      ]
    }
  },
  methods: {
    openAvatarCopper(index)
    {
      this.$refs.avatarCropperRef[index].open();
    },
    openResetPassword(item)
    {
      this.dialog = true;
      this.profileIdSelect = item.id;
      this.$v.$reset();
      if (this.$refs.form)
      {
        this.$refs.form.reset();
      }
    },
    loadPlaceholder(e)
    {
      e.target.src = this.errorImage;
    },
    async loadImage(url)
    {
      let urlImage = GeneralService.cleanImage(url, this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER'));
      return urlImage;
    },
    async selectParticipants(bandMounted = false)
    {
      this.participantList = this.participantList.filter((el) =>
      {
        const find = this.participant.find((ele) =>
        {
          return ele.userId ? el.userId == ele.userId : el.id == ele.id
        });
        return !!find;
      });
      const usersId = this.participant.map((el) => { return el.userId; });
      this.getProfileUsers(usersId, bandMounted);
      this.loadingProfile = false;
      //if (bandMounted) this.getStatesByCountry();
      AuthService.setAuthParticipants(this.userStore.id, this.participant);
    },
    async getParticipants()
    {
      if (!this.bandLoadingParticipants)
      {
        if (this.userStore)
        {
          this.bandLoadingParticipants = true;
          this.authUserId = this.userStore.id;
          this.$store.dispatch('setParticipantsAction');
          this.loadingProfile = false;
        } else
        {
          this.$store.dispatch('setUserAction');
        }
      }
    },
    submit()
    {
      this.wrong_password = false;
      this.$v.$touch();
      if (this.forgot_password)
      {
        if (this.$v.$invalid)
        {
          return;
        }
      } else
      {
        if (this.$v.verify_pass.$invalid || this.$v.new_pass.$invalid)
        {
          return;
        }
      }
      let data = { new_password: this.new_pass, userId: this.profileIdSelect, authenticated_change: true };
      this.snackbar = false;
      LoginService.resetPassword(data).then(response =>
      {
        if (response.data.message == "wrong_password")
        {
          this.wrong_password = true;
          this.showSnackBar(this.$t("profile.wrong_password"), "danger");
          this.dialog = false;
        } else
        {
          this.showSnackBar(this.$t("profile.success_password"), "success");
          this.success = true;
          this.dialog = false;
        }
      });
    },
    openSelfie(index)
    {
      this.$refs.selfieCropperRef[index].openSelfie();
    },
    submitSelfie()
    {

      let video = this.$refs.webcam;
      video.pause();
      var canvas = this.$refs.webcam_canvas;
      canvas.width = 360;
      canvas.height = 480;
      var ctx = canvas.getContext('2d');

      //draw image to canvas. scale to target dimensions
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      //convert to desired file format
      var dataURI = canvas.toDataURL('image/jpeg'); // can also use 'image/png'
      this.uploadSelfie(dataURI);

      video.play();
      //});
    },
    async getProfileUser(userId, bandMounted = false)
    {
      this.profile = {};
      let data = {
        userId,
        authUserId: this.authUserId
      };
      await ProfileService.getProfile(data).then(response =>
      {
        if (response.data.success == 1)
        {
          let data = response.data.message;
          this.profile.id = data.id;
          this.profile.firstName = data.firstName;
          this.profile.lastName = data.lastName;
          this.profile.email = data.emailAddress || '';
          this.profile._hasLivelapsEmail = false;
          this.profile.phone = data.phone;
          this.profile.gender = data.gender;
          this.profile.zip = data.zip;
          this.profile.address = data.address;
          this.profile.country = data.country;
          this.profile.state = data.state;
          this.profile.city = data.city;
          this.profile.image = data.image;
          this.profile.existFile = data.existFile;
          if (data.birthday && data.birthday.length > 0)
          {
            this.profile.date = data.birthday;
          }
        } else
        {
          this.showSnackBar(this.$t("profile." + response.data.success), "error");
        }
      });
      this.participantList = this.participantList.map((x) =>
      {
        if (x.id === userId)
        {
          return {
            ...x,
            id: this.profile.id,
            firstName: this.profile.firstName,
            lastName: this.profile.lastName,
            email: this.profile.email,
            _hasLivelapsEmail: this.profile._hasLivelapsEmail,
            phone: this.profile.phone,
            gender: this.profile.gender,
            zip: this.profile.zip,
            address: this.profile.address,
            state: bandMounted ? null : this.profile.state,
            stateLoad: this.profile.state,
            city: this.profile.city,
            country: this.profile.country,
            image: this.$store.getters.env.get('VUE_APP_DEV_API_HOST') + this.profile.image,
            menu: false,
            date: this.profile.date,
            birthday: this.profile.date
          };
        }
        return x;
      });
    },
    async getProfileUsers(usersId, bandMounted = false)
    {
      let data = {
        usersId,
        authUserId: this.authUserId
      };
      await ProfileService.getProfileUsers(data).then((response) =>
      {
        try{
          if (response.data.success == 1)
          {
            let data = response.data.message;
            this.languages = response.data.languages;
            this.participantList = this.participant.map((item) =>
            {
              let part = data.find((el) => { return item.userId == el.id });
              return {
                ...item,
                ...part,
                email: part.emailAddress || '',
                _hasLivelapsEmail: false,
                state: bandMounted ? null : part.state,
                stateLoad: part.state,
                image: this.$store.getters.env.get('VUE_APP_DEV_API_HOST') + part.image,
                menu: false,
                date: part.birthday
              };
            });
          } else
          {
            this.showSnackBar(this.$t("profile." + response.data.success), "error");
          }
        }catch(error){
          this.showSnackBar('unexpextedError', 'error');
        }
      });
      if (bandMounted) this.getStatesByCountry();
    },
    showSnackBar(msg, color)
    {
      if(!this.snackbar) this.snackbar = true;
      this.msg_snackbar = msg == 'unexpextedError' ? this.$t('common.unexpextedError') : msg;
      this.color_snackbar = color;
      setTimeout(() => this.snackbar = false, 6000);
    },
    loadCountries()
    {
      this.countryItems = countryregion.countries;
      GeneralService.getCountries().then((resp) =>
      {
        this.countryItems = resp.data;
      });
    },
    getStatesByCountry(item = null)
    {
      if (!item)
      {
          GeneralService.getStatesCountries({countries: []}).then((resp) =>
          {
            this.stateItems = resp.data;
            this.participantList.forEach((el) =>
            {
              el.state = el.stateLoad;
            });
            this.loadStatesCountryEmpty();
          }).catch(() => {
            this.stateItems = {};
          });
      } else {
        if (!this.stateItems[item.state])
        {
          GeneralService.getStates(item.country).then((resp) =>
          {
            this.stateItems[item.country] = resp.data;
          });
        }
      }
    },
    goRegisterEvent()
    {
      this.$router.push({
        path: "registerEventDashboard"
      });
    },
    emptyVerify(v)
    {
      return !!(v || '').length > 0;
    },
    phoneVerify(v)
    {
      return !!(v || '').match(/^[0-9:-]{12,99}$/);
    },
    send(userId, value, field)
    {
      const part = this.participantList.find((el) =>
      {
        return el.id == userId;
      });
      this.snackbar = false;
      switch (field)
      {
        case "phone":
          this.updatePhone(userId, value);
          break;
        case "gender":
          this.updateField({ "userId": userId, "field": "gender", "value": value, "authUserId": this.authUserId });
          break;
        case "firstName":
          this.updateName(userId, value, field, "firstName");
          break;
        case "lastName":
          this.updateName(userId, value, field, "lastName");
          break;
        case "address":
          this.updateAddress(userId, value);
          break;
        case "zip":
          if (this.emptyVerify(part.zip))
            this.updateField({ "userId": userId, "field": "zip", "value": value, "authUserId": this.authUserId });
          else
            this.showSnackBar(this.$t("profile.error_zip"), "error");
          break;
        case "country":
          this.updateField({ "userId": userId, "field": "country", "value": value, "authUserId": this.authUserId });
          break;
        case "state":
          this.updateField({ "userId": userId, "field": "state", "value": value, "authUserId": this.authUserId });
          break;
        case "city":
          if (this.emptyVerify(part.city))
            this.updateField({ "userId": userId, "field": "city", "value": value, "authUserId": this.authUserId });
          else
            this.showSnackBar(this.$t("profile.error_city"), "error");
          break;
        case "email":
          this.updateEmail(userId, value);
          break;
        case "date":
          if (this.age18)
            this.updateField({ "userId": userId, "field": "birthday", "value": value, "authUserId": this.authUserId });
          else
          {
            part.date = part.birthday;
            this.showSnackBar(this.$t("profile.error_minor"), "error");
          }
          break;
      }
    },
    updateEmail(userId, _email)
    {
      if (_email.length == 0)
      {
        this.$refs['email'][0].focus();
        this.showSnackBar(this.$t("profile.error_email"), "error");
      } else
      {
        ProfileService.updateEmail({ "userId": userId, "email": _email, "authUserId": this.authUserId }).then(response =>
        {
          try
          {
            if (response.data.success == 1)
            {
              this.getProfileUser(userId);
              if (userId == this.authUserId)
              {
                this.$store.dispatch('setUserAction', { forceUpdate: true, forceParticipants: true });
              } else
              {
                this.$store.dispatch('setParticipantsAction');
              }
              if (response.data.message == "unique_email")
              {
                this.showSnackBar(this.$t("profile.unique_email"), "error");
              } else
              {
                this.showSnackBar(this.$t("profile.msg_record_sucess"), "success");
              }
            }
          }catch(error){
            this.showSnackBar('unexpextedError', 'error');
          }
        });
      }
    },
    updateAddress(userId, address)
    {
      if (address.length == 0)
      {
        this.msg_snackbar = this.$t("profile.error_address");
        this.color_snackbar = "error";
        this.snackbar = true;
      } else
      {
        this.updateField({ "userId": userId, "field": "address", "value": address, "authUserId": this.authUserId });
      }
    },
    updateName(userId, names, field, _f)
    {
      const patternName = /^[a-zA-Z\u00C0-\u017F\-' ]+/;
      const valueMatch = (names || '').match(patternName);
      if (names.length == 0)
      {
        this.showSnackBar(this.$t("profile.error_empty"), "error");
        this.$refs[_f][0].focus();
      } else if (!(!!valueMatch && valueMatch[0] == valueMatch.input))
      {
        this.showSnackBar(this.$t("profile.invalid_field"), "error");
        this.$refs[_f][0].focus();
      } else
      {
        this.updateField({ "userId": userId, "field": field, "value": names, "authUserId": this.authUserId });
      }
    },
    updatePhone(userId, phone)
    {
      if (phone.match(/^[0-9-]{10,12}$/))
      {
        const simbol = phone.split("-")
        if (simbol.length > 3)
        {
          this.showSnackBar(this.$t("profile.phone_invalid"), "error");
        } else
        {
          phone = phone.replaceAll("-", "")
          if (phone.length < 10)
          {
            this.showSnackBar(this.$t("profile.phone_invalid"), "error");
          } else if (phone.length > 10)
          {
            this.showSnackBar(this.$t("profile.phone_invalid"), "error");
          } else
          {
            phone = phone.substring(0, 3) + "-" + phone.substring(3, 6) + "-" + phone.substring(6, 10)
            this.updateField({ "userId": userId, "field": "phone", "value": phone, "authUserId": this.authUserId });
          }
        }

      } else
      {
        this.$refs['phone'][0].focus();
        if (!phone)
          this.showSnackBar(this.$t("profile.phone_required"), "error");
        else
          this.showSnackBar(this.$t("profile.phone_invalid"), "error");
      }
    },
    updateField(data)
    {
      ProfileService.updateField(data).then(response =>
      {
        try{
          if (response.data.success == 1)
          {
            this.selectParticipants();
            if (response.data.message == 1)
            {
              this.showSnackBar(this.$t("profile.msg_record_sucess"), "success");
              const { userId, authUserId } = data;
              if (userId == authUserId)
              {
                this.$store.dispatch('setUserAction', { forceUpdate: true, forceParticipants: true });
              } else
              {
                this.$store.dispatch('setParticipantsAction');
              }
            }
          }
        }catch(error){
          this.showSnackBar('unexpextedError', 'error');
        }
      });
    },
    updateGooglePlacesAdressData(data)
    {
      ProfileService.googlePlacesUpdate(data).then(response =>
      {
        try{
          if (response.data.success == 1)
          { 
            this.selectParticipants();
            if (response.data.message == 1)
            {
              this.showSnackBar(this.$t("profile.msg_record_sucess"), "success");
              const { userId, authUserId } = data;
              if (userId == authUserId)
              {
                this.$store.dispatch('setUserAction', { forceUpdate: true, forceParticipants: true });
              } else
              {
                this.$store.dispatch('setParticipantsAction');
              }
            }
          }
        }catch(error){
          this.showSnackBar('unexpextedError', 'error');
        }
      });
    },
    upload(id = 0)
    {
      document.getElementById("uploadImage_" + id).click();
    },
    async onImageChange(e, userId)
    {
      this.uploadImage_ = e.target.files[0];
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.fileName = files[0].name;
      this.uploadImage(userId);
    },
    async createImage(file)
    {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) =>
      {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async uploadSelfie(dataURI)
    {
      let userId = this.userIdSelfie;
      const data = new FormData();
      data.append("image", dataURI);
      data.append("userId", userId);

      let axiosConfig = {
        headers: { "content-type": "multipart/form-data" },
      };

      const response = await axios
        .put(
          `${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/profile/selfie/`,
          data,
          axiosConfig
        )
        .catch(
          function (error)
          {
            if(!error.response)
            {
              this.showSnackBar('unexpextedError', 'error');
              return false;
            }
            const status = error.response.status;

            switch (status)
            {
              case 401:
                this.$router.push({ name: "Login" });
                break;
            }
          }.bind(this)
        );
      try{
        if (response.data.success == 1)
        {
          this.dialogSelfie = false;
          if (userId == this.authUserId)
          {
            this.$store.dispatch('setUserAction', { forceUpdate: true, forceParticipants: true });
          } else
          {
            this.$store.dispatch('setParticipantsAction');
          }
          this.selectParticipants(true);
        }
      }catch(error){
        this.showSnackBar('unexpextedError', 'error');
      }
    },
    uploadCropperImage(data)
    {
      const { userId, base64Image, fileName } = data;
      const base64Data = base64Image.replace(/^data:image\/\w+;base64,/, "");
      var byteCharacters = atob(base64Data);

      var byteArray = new Uint8Array(byteCharacters.length);

      for (var i = 0; i < byteCharacters.length; i++)
      {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }

      var blob = new Blob([byteArray], { type: 'image/png' });

      // Crea un objeto de tipo File a partir del Blob
      var file = new File([blob], 'filename.png', { type: 'image/png' });

      this.uploadImage_ = file;
      this.fileName = fileName;
      this.uploadImage(userId);
    },
    async uploadImage(userId)
    {
      const data = new FormData();
      data.append("image", this.uploadImage_);
      data.append("fileName", this.fileName);
      data.append("userId", userId);

      let axiosConfig = {
        headers: { "content-type": "multipart/form-data", "files": true },
      };

      const response = await axios
        .put(
          `${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/profile/picture/`,
          data,
          axiosConfig
        )
        .catch(
          function (error)
          {
            if(!error.response)
            {
              this.showSnackBar('unexpextedError', 'error');
              return false;
            }
            const status = error.response.status;

            switch (status)
            {
              case 401:
                this.$router.push({ name: "Login" });
                break;
            }
          }.bind(this)
        );
      if (response && response.data && response.data.success == 1)
      {
        if (userId == this.authUserId)
        {
          this.$store.dispatch('setUserAction', { forceUpdate: true, forceParticipants: true });
        } else
        {
          this.$store.dispatch('setParticipantsAction');
        }
        this.selectParticipants(true);
      } else
      {
        const errors = response.data.message;
        errors.forEach((error) =>
        {
          this.showSnackBar(this.$t("profile." + error), "error");
        });
      }
    },
    async ImgError()
    {
      this.failed_image = false;
      this.imageUrlProfile = require("@/assets/images/partPlaceholder.jpg");
    },
    openDeleteImage(userId)
    {
      this.userIdDelete = userId;
      this.dialogDeleteImg = true;
    },
    deleteImg(userId)
    {
      ProfileService.deleteProfileImage(userId).then(response =>
      {
        if (response.data.success == 1)
        {
          this.showSnackBar(this.$t("profile.success-deleteimg"), "success");
          if (userId == this.authUserId)
          {
            this.$store.dispatch('setUserAction', { forceUpdate: true, forceParticipants: true });
          } else
          {
            this.$store.dispatch('setParticipantsAction');
          }
          this.selectParticipants();
        } else
        {
          this.showSnackBar(this.$t("profile.error-deleteimg"), "error");
        }
        this.dialogDeleteImg = false;
      });
    },
    changeSelect(selectParts)
    {
      this.$store.commit('setParticipantsSelected', selectParts);
    },
    restrictFormat($event, part)
    {

      if (!((part.phone || "").replace("-", "").length <= 10 && (/\d/.test(String.fromCharCode($event.charCode)) || String.fromCharCode($event.charCode) == '-')) || (part.phone || "").replace("-", "").length > 10)
      {
        $event.preventDefault();
      } else
      {
        if (
          ((part.phone || "").length == 3 && String.fromCharCode($event.charCode) != '-') ||
          ((part.phone || "").length == 7 && String.fromCharCode($event.charCode) != '-')
        )
        {
          $event.preventDefault();
        } else if (
          (((part.phone || "").length < 3 || ((part.phone || "").length > 3 && (part.phone || "").length < 7) || (part.phone || "").length > 7) && !/\d/.test(String.fromCharCode($event.charCode)))
        )
        {
          $event.preventDefault();
        } else if ((part.phone || "").replace("-", "").length == 2 || (part.phone || "").replace("-", "").length == 5)
        {
          $event.preventDefault();
          part.phone += $event.key + '-';
        }
      }
    },
    sendLanguage(userId, value, field)
    {
      this.updateLanguage(userId, value, field);

      if (this.authUserId == userId)
      {
        this.selectLang(value);
      }
    },
    selectLang(lang)
    {
      this.$i18n.locale = lang;
      LanguageService.postSetSession({ languageCode: lang, localeManual: 1 }).then((resp) =>
      {
        if (resp.data.success)
        {
          this.$store.dispatch('setLanguageId', resp.data.message.id);
        }
        this.$store.dispatch('setLanguageCode', this.$i18n.locale);
        const lang1 = {
          id: this.$store.state.session.languageId,
          code: this.$i18n.locale
        };
        LocalStorageService.setItem("languagePart", lang1);
      });
    },
    updateLanguage(userId, value, field)
    {
      let data = {
        authUserId: this.authUserId,
        field,
        userId,
        value
      };
      ProfileService.updateProfileLanguage(data).then(response =>
      {
        try
        {
          if (response.data.success == 1)
          {
            this.selectParticipants();
            if (response.data.message == 1)
            {
              this.showSnackBar(this.$t("profile.msg_record_sucess"), "success");
              const { userId, authUserId } = data;
              if (userId == authUserId)
              {
                this.$store.dispatch('setUserAction', { forceUpdate: true, forceParticipants: true });
              } else
              {
                this.$store.dispatch('setParticipantsAction');
              }
            }
          }
        }
        catch(error)
        {
          this.showSnackBar('unexpextedError', 'error');
        }
      });
    },
    verifyCountry(part) {
      if((part.country || "").length == 0) {
        let msg = this.$t("profile.error_country");
        this.showSnackBar(msg, "error");
      }
    },
    loadStatesCountryEmpty() {
      if(this.participantList.length > 0) {
        let errorStates = this.participantList.find((participant) => {
          return (participant.country || "").length == 0 && (participant.stateLoad || "").length > 0;
        });
        if(errorStates) {
          let allStates = [];
          this.countryItems.forEach((country) => {
            allStates = allStates.concat(this.stateItems[country]);
          });
          this.stateItems.all = allStates;
        }
      }
    },
  },
  mounted()
  {
    this.$emit("titlePage", "profile.title");
    this.loadCountries();
    this.getStatesByCountry();
    this.getParticipants();
  },
  created()
  {
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.headerColor = this.$store.getters.env.get('VUE_APP_HEADER_COLOR');
    this.cardBGColor = this.$store.getters.env.get('VUE_APP_BACKGROUND_CARD_PART');
    this.borderAlertColor = this.$store.getters.env.get('VUE_APP_BORDER_ALERT_REGULAR');
    this.iconAlertColor = this.$store.getters.env.get('VUE_APP_ICON_ALERT_REGULAR');
    this.bgAlertColor = this.$store.getters.env.get('VUE_APP_BG_ALERT_REGULAR');
  },
  watch: {
    userStore(val)
    {
      if (val)
      {
        this.getParticipants();
      }
    },
    participant()
    {
      if (!this.bandLoadingPartSelected)
      {
        this.bandLoadingPartSelected = true;
        this.selectParticipants(true);
      }
    },
    localeLang(val)
    {
      this.participantList.forEach((part) =>
      {
        if (part.userId == this.authUserId)
        {
          part.languageCode = val;
        }
      });
    },
    spaceCleaner(val, oldVal){
        const fields = val;
        const fieldsOld = oldVal;
        this.$nextTick(() => {
          if(fields[0] != fieldsOld[0]){
            this.new_pass = this.$inputFormatter(fields[0], 'spaceCleaner');
          }
          if(fields[1] != fieldsOld[1]){
            this.verify_pass = this.$inputFormatter(fields[1], 'spaceCleaner');
          }
        });
    },
    addressDataComponentUpdateVersion()
    {
      const userId = this.addressDataComponentUpdateId;
      if(!userId)
      {
        this.msg_snackbar = 'addressDataComponentUpdateId';
        this.color_snackbar = 'error';
        this.snackbar = true;
        return;
      }
      
      if(this.addressDataComponents.length == 0)
      {
        this.msg_snackbar = 'addressDataComponents';
        this.color_snackbar = 'error';
        this.snackbar = true;
        return;
      }
      
      const index = this.addressDataComponents.findIndex(obj => obj.updateId == userId);
      const addressComponent = this.addressDataComponents[index];
      const keys = Object.keys(addressComponent);
      
      if(keys.length == 0)
      {
        this.msg_snackbar = 'addressComponentToUpdate 0 keys';
        this.color_snackbar = 'error';
        this.snackbar = true;
        return;
      }

      this.$store.commit('setOverlay', true);
      let data = {};
      data.userId = userId;
      data.fields = {};

      for (const paramName of keys)
      {
        
        const value = addressComponent[paramName];
        if(value == data.userId) continue;
        data.fields[paramName] = value
      }
      this.updateGooglePlacesAdressData(data);
      this.$store.commit('setOverlay', false);
    },
  }
};
</script>

<style lang="scss">

#profilePage {
  .map-container
  {
    background-color: #e9f2f1;
    border-left: 0px !important;
    border-right: 0px !important;
    border-top: 0px !important;
    border-radius: 0px !important;

    .map-label
    {
      height: 9px;
      display: block;
      color: rgba(0, 0, 0, 0.6);
      font-size: small;
      margin: 0px;
      padding: 0px;
      line-height: 10px;
    }

    .map-icon
    {
      font-size: x-large;
      float: right;
      color: #6b6a6a;
      margin-bottom: -53px;
      margin-top: -5px;
      margin-right: 5px;
    }

    input.places {
      width: 100%;
      outline: none;
      padding-right: 45px;
      color: #272727;
    }
  }

  .map-container:hover
  {
    background-color: #ccdbda;
  }

  .containImg {
    padding: 4px;
    border-radius: 4px 4px 0 0;
    border: 1px solid #ddd;
    background-color: white;
    padding-bottom: 30px;
    max-width: 350px;
    margin: 0 auto;
  }

  .boxAvatar {
    max-width: 350px;
    margin: 0px;
  }

  .btnImgCenter {
    max-width: 350px;
    border-radius: 0px;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    width: 100%;
  }

  .btnImgDelete {
    width: 40px;
    min-width: 40px !important;
    max-width: 40px;
    border-radius: 0 0 0 0;
  }

  .btnImgEnd {
    border-radius: 0;
    width: calc(100% - 40px);
    border-left: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }

  .btnImgEnd span.v-btn__content,
  .btnImgCenter span.v-btn__content {
    text-transform: none;
    font-size: 12px;
  }

  .color-prof {
    color: #5a5a5a !important;
  }

  .text-line {
    border-bottom: dashed 1px #ccc !important;
  }

  .small-msg {
    display: block;
  }

  .name-profile {
    font-size: 30px;
  }

  .profile-info {
    color: #aaa;
    padding: 10px 0;
    font-size: 12px;
  }

  .btn-profile {
    color: #fff !important;
  }

  .profile-info span,
  .description-profile .v-btn:not(.link-name) span,
  .description-profile>p a {
    padding-left: 5px;
  }

  .description-profile>p:not(.profile-info),
  .description-profile>p a {
    color: #5a5a5a !important;
    font-size: 14px;
    font-weight: bold;
  }

  .description-profile>p:not(.profile-info)>.v-icon {
    color: #5a5a5a !important;
  }

  .input_str .v-input__control {
    height: 40px;
  }

  .input_str .v-input__slot {
    min-height: 40px !important;
  }

  .bottom_bt {
    text-align: left;
  }

  .theme--light.v-input--is-disabled input {
    color: #000 !important;
  }

  .input_small .v-text-field__details {
    margin-bottom: 1px !important;
  }

  .input_small .v-input__slot {
    margin-bottom: 0px !important;
  }

  .icon_btn {
    position: absolute !important;
    right: 0;
    top: 0;
  }

  .input_small.v-text-field--filled.v-input--dense>.v-input__control>.v-input__slot,
  .input_small.v-text-field--filled.v-input--dense>.v-input__control>.v-select__slot {
    min-height: 38px;
  }

  .input_small.v-text-field--filled.v-input--dense .v-label {
    top: 12px;
  }

  .input_small.v-text-field--filled:not(.v-text-field--single-line) input {
    margin-top: 12px;
  }

  .input_small.v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__selections {
    padding-top: 12px;
  }

  .input_small.v-text-field--filled:not(.v-text-field--single-line) .v-select__selections>input {
    margin-top: 0px;
  }

  .input_small.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo) .v-input__append-inner {
    margin-top: 7px;
  }

  .input_small.theme--light.v-text-field--filled>.v-input__control>.v-input__slot {
    background: rgba(255, 255, 255, 0.4);
  }

  .input_small.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
    background: rgba(0, 0, 0, .05);
  }

  /*.imgAvatar { max-width: 100%; width: 342px; height: 260px; object-fit: contain; }*/
  .imgAvatar {
    max-width: 100%;
    object-fit: contain;
  }

  .avatar-action-buttons {
    float: right !important;
    margin-top: -39px !important;
  }

  @media (min-width: 1260px) and (max-width: 1590px) {
    /*.imgAvatar { object-fit: cover; }*/
  }

  @media (max-width: 600px) {
    .bottom_bt {
      text-align: center;
    }
  }
}
</style>
